module.exports = {"441423103":"北斗镇","441423104":"汤西镇","441423105":"汤南镇","441423106":"埔寨镇","441423110":"建桥镇","441423111":"龙岗镇","441423112":"潘田镇","441423114":"黄金镇","441423122":"小胜镇","441423123":"砂田镇","441423124":"八乡山镇","441423125":"丰良镇","441423126":"潭江镇","441423127":"汤坑镇","441423128":"留隍镇","441423129":"大龙华镇","441423450":"埔寨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441423.json
// module id = 1853
// module chunks = 0